module.exports = __webpack_public_path__ + "static/media/badge-gtm.fe0af587.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/badge-gtm.png
// module id = 320
// module chunks = 0